import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type StatusBadgeStatus = 'success' | 'warning' | 'danger' | 'neutral';

@Component({
  selector: 'app-status-badge',
  standalone: false,
  template: '<span class="status-badge" [class]="statusClass">{{ label() }}</span>',
  styleUrls: ['./status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusBadgeComponent {
  readonly status = input<StatusBadgeStatus>('neutral');
  readonly label = input('');

  get statusClass(): string {
    return `status-badge--${this.status()}`;
  }
}